import { Element } from "../Element.mjs";
export var PlaceholderNode;

(function (PlaceholderNode) {
  function isPlaceholderType(type) {
    return type.startsWith('placeholder:');
  }

  PlaceholderNode.isPlaceholderType = isPlaceholderType;

  function isPlaceholderNode(value, type) {
    if (type !== undefined) {
      return Element.isElement(value, type);
    }

    return Element.isElement(value) && isPlaceholderType(value.type);
  }

  PlaceholderNode.isPlaceholderNode = isPlaceholderNode;

  function validatePlaceholderNode(value) {
    var isValid = isPlaceholderNode(value) && typeof value.uuid === 'string';
    return isValid ? value : null;
  }

  PlaceholderNode.validatePlaceholderNode = validatePlaceholderNode;
})(PlaceholderNode || (PlaceholderNode = {}));